<template>
  <button 
    @click="$emit('open-modal')"
    class="bug-report-btn"
    :style="buttonStyle"
  >
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="currentColor"/>
    </svg>
    {{ buttonText }}
  </button>
</template>

<script>
export default {
  name: 'BugReportButton',
  
  props: {
    buttonText: {
      type: String,
      required: true
    },
    buttonStyle: {
      type: Object,
      default: () => ({})
    }
  },
  
  emits: ['open-modal']
}
</script>

<style scoped>
.bug-report-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.bug-report-btn:hover {
  background: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
</style>